import * as ColorName from 'color-name';

interface ColorNames {
  [index: string]: [number, number, number];
}

export default ColorName as ColorNames;
